export enum StorageOPEEnum {
  PutFile = 'putFile',
  DelFiles = 'delFiles',
}
